<template>
  <v-container id="viaticos-form" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" md="8">
        <base-material-card color="#ac8a2e" inline title="Viáticos">
          <template v-slot:after-heading>
            <div class="font-weight-light card-title mt-2">
              {{ tittle }}
            </div>
          </template>
          <validation-observer v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(validateForm)">
              <v-container class="py-0">
                <v-row>
                  <v-col cols="12" md="6">
                    <v-menu
                      ref="menu"
                      v-model="menu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      min-width="290px"
                      offset-y
                      :disabled="esVista"
                    >
                      <template v-slot:activator="{ on }">
                        <validation-provider v-slot="{ errors }" name="fecha" rules="required">
                          <v-text-field v-model="dataForm.fecha" :disabled="esVista" color="gold" :error-messages="errors" label="Fecha" readonly v-on="on" />
                        </validation-provider>
                      </template>
                      <v-date-picker
                        v-model="dataForm.fecha"
                        color="gold"
                        landscape
                        scrollable
                        locale="es-419"
                        no-title
                        @input="menu = false"
                      />
                    </v-menu>
                  </v-col>
                  <v-col cols="12" md="6">
                    <validation-provider
                      v-slot="{ errors }"
                      name="jugador"
                      rules="required"
                    >
                      <v-autocomplete
                        v-model="dataForm.jugador_id"
                        color="gold"
                        :error-messages="errors"
                        label="Jugador"
                        item-value="id"
                        item-text="fullName"
                        :items="jugadores"
                        :disabled="esJugador || esVista"
                        clearable
                      >
                        <template v-slot:item="{ attrs, item, on }">
                          <v-list-item v-bind="attrs" active-class="gold elevation-4 white--text" class="mx-3 mb-3 v-sheet" elevation="0" v-on="on">
                            <v-list-item-content>
                              <v-list-item-title v-text="item.fullName" />
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                      </v-autocomplete>
                    </validation-provider>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <validation-provider
                      v-slot="{ errors }"
                      name="obligacion"
                      rules="required"
                    >
                      <v-select
                        v-model="dataForm.obligacion_id"
                        color="gold"
                        :error-messages="errors"
                        label="Obligación"
                        item-value="id"
                        item-text="descripcion"
                        :items="obligaciones"
                        :disabled="esVista"
                        clearable
                      >
                        <template v-slot:item="{ attrs, item, on }">
                          <v-list-item v-bind="attrs" active-class="gold elevation-4 white--text" class="mx-3 mb-3 v-sheet" elevation="0" v-on="on">
                            <v-list-item-content>
                              <v-list-item-title v-text="item.descripcion" />
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                      </v-select>
                    </validation-provider>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <validation-provider
                      v-slot="{ errors }"
                      name="cantidad"
                      rules="required"
                    >
                      <v-text-field
                        v-model="dataForm.cantidad"
                        color="#ac8a2e"
                        :error-messages="errors"
                        :label="cantidadMonto"
                        type="number"
                        min="0"
                        :disabled="esVista"
                      />
                    </validation-provider>
                  </v-col>
                  <v-col cols="12">
                    <validation-provider
                      v-slot="{ errors }"
                      name="descripcion"
                      rules="required|max:250"
                    >
                      <v-textarea
                        v-model="dataForm.descripcion"
                        color="#ac8a2e"
                        :error-messages="errors"
                        name="input-6-1"
                        label="Descripción"
                        :disabled="esVista"
                      />
                    </validation-provider>
                  </v-col>
                  <v-col
                    cols="12"
                  >
                    <v-row
                      justify="space-between"
                    >
                      <v-btn v-if="mode !=='show'" :disabled="$disabled()" color="#ac8a2e" class="mr-0" type="submit">
                        Guardar
                      </v-btn>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </form>
          </validation-observer>
        </base-material-card>
      </v-col>
    </v-row>
    <v-divider />
    <v-row v-show="dataForm.pagos_id || dataForm.valor_monetario > 0 || dataForm.fecha_rechazo" justify="center">
      <v-col cols="12" md="8">
        <base-material-card
          :color="dataForm.fecha_rechazo ? '#B71C1C' : '#2E7D32'"
          :title="dataForm.fecha_rechazo ? 'Rechazado' : 'Pago'"
          inline
        >
          <template v-if="dataForm.fecha_rechazo">
            <v-textarea :value="dataForm.motivo_rechazo" class="pa-3 pt-5" name="input-7-1" rows="4" color="#ac8a2e" label="Motivo Rechazo" disabled />
          </template>
          <template v-else-if="dataForm.pago || dataForm.valor_monetario > 0">
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field :value="dataForm.pago ? dataForm.pago.fecha : dataForm.fecha" color="#ac8a2e" label="Fecha" disabled />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field :value="calcularMonto" color="#ac8a2e" label="Monto" disabled />
              </v-col>
            </v-row>
          </template>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    props: {
      mode: {
        type: String,
        required: true,
      },
      id: {
        type: Number,
        required: false,
        default: 0,
      },
    },

    data: () => ({
      tittle: 'Nuevo',
      menu: false,
      esVista: false,
      esJugador: false,
      obligaciones: [],
      jugadores: [],
      headers: [
        { text: 'Fecha', align: 'start', sortable: true, value: 'fecha' },
        { text: 'Monto', sortable: true, value: 'monto' },
      ],
      dataForm: {
        id: '',
        fecha: '',
        obligacion_id: '',
        descripcion: '',
        cantidad: '',
        fecha_rechazo: '',
        motivo_rechazo: '',
        pagos_id: '',
        jugador_id: '',
        valor_monetario: '',
      },
    }),
    computed: {
      calcularMonto () {
        return '$' + (this.dataForm.pago ? this.dataForm.pago.monto : this.dataForm.valor_monetario)
      },
      cantidadMonto () {
        var obligacion = this.obligaciones.find(x => x.id === this.dataForm.obligacion_id)
        if (obligacion && obligacion.valor_monetario_sn) {
          return 'Monto'
        } else {
          return 'Cantidad'
        }
      },
    },
    created () {
      this.getObligaciones()
      this.getJugadores()
      if (this.mode === 'edit') {
        this.tittle = 'Editar Viático'
        this.getViatico()
      } else if (this.mode === 'new') {
        this.tittle = 'Nuevo Viático'
        this.setJugador()
      } else {
        this.tittle = 'Ver Viático'
        this.esVista = true
        this.getViatico()
        this.setHeaders()
      }
    },
    methods: {

      setJugador: function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/jugador_loged' }).then(response => {
          if (response) {
            this.dataForm.jugador_id = response
            this.esJugador = true
          }
        })
      },

      setHeaders: function () {
        this.headers = [
          { text: 'Fecha', value: 'fecha', sortable: false },
          { text: 'Total', value: 'total', sortable: false },
        ]
      },

      getViatico: function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/solicitudes_extraordinarias/' + this.id }).then(response => {
          this.dataForm = response
        })
      },

      getObligaciones: function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/obligaciones' }).then(response => { this.obligaciones = response })
      },

      getJugadores: function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/jugador' }).then(response => { this.jugadores = response })
      },

      validateForm (scope) {
        this.saveViatico()
      },

      saveViatico: async function () {
        const mode = this.mode === 'new' ? 'postData' : 'putData'
        await this.$store.dispatch('axiosMod/' + mode, { url: '/api/solicitudes_extraordinarias_agregar', dataForm: this.dataForm }).then(response => {
          this.$store.commit('toast/show', { tipo: 'success', messages: ['Alta de viático exitosa'] })
          this.$router.push({ name: 'Listado viaticos' }).catch(error => {
            if (error.response.data.errors) {
              this.$store.commit('toast/show', { tipo: 'error', messages: [error.response.data.errors] })
            } else if (error.response.data) {
              this.$store.commit('toast/show', { tipo: 'error', messages: [error.response.data] })
            } else {
              this.$store.commit('toast/show', { tipo: 'error', messages: ['Ocurrio un error en el servidor'] })
            }
          })
        })
      },
    },
  }
</script>
<style>
    .v-textarea {
      font-size: 16px;
    }
</style>
